var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconeEducacao(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 136.505,
    height: 50,
    viewBox: "0 0 136.505 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3187",
    "data-name": "Grupo 3187",
    transform: "translate(3648 4829.06)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3153",
    "data-name": "Grupo 3153",
    transform: "translate(-3636.307 -4815.215)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linha_297",
    "data-name": "Linha 297",
    y2: 10.205,
    transform: "translate(10.205) rotate(90)",
    fill: "none",
    stroke: "#edb819",
    strokeLinecap: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3154",
    "data-name": "Grupo 3154",
    transform: "translate(-3623.125 -4802.034)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linha_297-2",
    "data-name": "Linha 297",
    y2: 10.205,
    transform: "translate(10.205) rotate(90)",
    fill: "none",
    stroke: "#005ba2",
    strokeLinecap: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3155",
    "data-name": "Grupo 3155",
    transform: "translate(-3523.2 -4813.514)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linha_297-3",
    "data-name": "Linha 297",
    y2: 10.205,
    transform: "translate(10.205) rotate(90)",
    fill: "none",
    stroke: "#005ba2",
    strokeLinecap: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3156",
    "data-name": "Grupo 3156",
    transform: "translate(-3538.508 -4804.16)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Linha_297-4",
    "data-name": "Linha 297",
    y2: 10.205,
    transform: "translate(10.205) rotate(90)",
    fill: "none",
    stroke: "#edb819",
    strokeLinecap: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_210",
    "data-name": "Elipse 210",
    transform: "translate(-3648 -4805.223)",
    fill: "none",
    stroke: "#005ba2",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.89,
    cy: 4.89,
    r: 4.89,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.89,
    cy: 4.89,
    r: 3.39,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_211",
    "data-name": "Elipse 211",
    transform: "translate(-3545.099 -4818.404)",
    fill: "#005ba2",
    stroke: "#005ba2",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.701,
    cy: 1.701,
    r: 1.701,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.701,
    cy: 1.701,
    r: 0.201,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_212",
    "data-name": "Elipse 212",
    transform: "translate(-3520.011 -4800.12)",
    fill: "#edb819",
    stroke: "#edb819",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.701,
    cy: 1.701,
    r: 1.701,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.701,
    cy: 1.701,
    r: 0.201,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3157",
    "data-name": "Grupo 3157",
    transform: "translate(-3606.319 -4829.06)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4299",
    "data-name": "Caminho 4299",
    d: "M428.261,461.384a1.405,1.405,0,0,0-1.406-1.4H404.92a1.4,1.4,0,0,0,0,2.809h21.935A1.408,1.408,0,0,0,428.261,461.384Z",
    transform: "translate(-390.809 -449.042)",
    fill: "#005ba2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4300",
    "data-name": "Caminho 4300",
    d: "M405.7,461.313a1.4,1.4,0,1,0,0,2.809h16.379a1.4,1.4,0,0,0,0-2.809Z",
    transform: "translate(-388.807 -445.595)",
    fill: "#005ba2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4301",
    "data-name": "Caminho 4301",
    d: "M410.711,464.072a5.2,5.2,0,1,0,5.2,5.2A5.2,5.2,0,0,0,410.711,464.072Zm2.389,5.2a2.387,2.387,0,1,1-2.389-2.389A2.387,2.387,0,0,1,413.1,469.27Z",
    transform: "translate(-385.634 -438.458)",
    fill: "#edb819"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4302",
    "data-name": "Caminho 4302",
    d: "M425.021,476.626a9.463,9.463,0,1,0-11.78,4.559L411,485.941l-.287-1.166a1.4,1.4,0,0,0-1.933-.951l-1.18.524,2.009-4.125-2.525-1.23-3.695,7.594a1.406,1.406,0,0,0,1.837,1.9l3.16-1.41.829,3.386a1.415,1.415,0,0,0,1.223,1.065c.047,0,.1.007.143.007a1.413,1.413,0,0,0,1.27-.807l4.215-8.943c.176.007.348.025.524.025s.352-.018.527-.025l4.215,8.943a1.413,1.413,0,0,0,1.27.807c.047,0,.1,0,.144-.007a1.415,1.415,0,0,0,1.223-1.065l.829-3.386,3.164,1.41a1.4,1.4,0,0,0,1.837-1.89Zm-1.776-4.279a6.656,6.656,0,1,1-6.658-6.654A6.664,6.664,0,0,1,423.245,472.346Zm-.118,6.826,2.486,5.191-1.212-.538a1.4,1.4,0,0,0-1.934.951l-.287,1.166-2.238-4.757A9.5,9.5,0,0,0,423.127,479.173Z",
    transform: "translate(-391.511 -441.534)",
    fill: "#edb819"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4303",
    "data-name": "Caminho 4303",
    d: "M399.974,456.932v37.585H414.03v-2.809H402.783V459.74h44.54v31.967h-11v2.809h13.811V456.932Z",
    transform: "translate(-399.974 -456.932)",
    fill: "#005ba2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4304",
    "data-name": "Caminho 4304",
    d: "M408.837,458.091h-7.655v7.657h2.809V460.9h4.846Z",
    transform: "translate(-396.852 -453.933)",
    fill: "#005ba2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4305",
    "data-name": "Caminho 4305",
    d: "M418.272,465.747v-7.657h-7.657V460.9h4.848v4.848Z",
    transform: "translate(-372.444 -453.933)",
    fill: "#005ba2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4306",
    "data-name": "Caminho 4306",
    d: "M410.615,471.772h7.657v-7.657h-2.809v4.848h-4.848Z",
    transform: "translate(-372.444 -438.345)",
    fill: "#005ba2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_4307",
    "data-name": "Caminho 4307",
    d: "M401.181,464.116v7.657h7.655v-2.809H403.99v-4.848Z",
    transform: "translate(-396.852 -438.345)",
    fill: "#005ba2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeEducacao);
export default __webpack_public_path__ + "static/media/icone-educacao.41be4b6bb012539d86442dd325487d1e.svg";
export { ForwardRef as ReactComponent };